import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import OurValues from './Pages/OurValues';
import OurOffering from './Pages/OurOffering';
import ProjectOverview from './Pages/ProjectOverview';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
        <Route path='/' element={<LandingPage/>} />
        <Route path='/ourValues' element={<OurValues/>} /> 
        <Route path='/ourOffering' element={<OurOffering/>} />
        <Route path='/overview' element={<ProjectOverview/>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;